// @index: export * from ${relpath}
export * from './intercept'
// /index